module.exports = __webpack_public_path__ + "img/logo-large.5fcbcf6f.png";